import queryString from 'query-string';
import { requestWithAuth } from './utils';

export const fetchReports = (queryParams) => {
  const query = queryString.stringify(queryParams, { arrayFormat: 'bracket' });
  return requestWithAuth(`${process.env.REACT_APP_API_HOST}/api/v1/campaigns?${query}`);
};

export const fetchReportsSummary = (queryParams) => {
  const query = queryString.stringify(queryParams, { arrayFormat: 'bracket' });
  return requestWithAuth(`${process.env.REACT_APP_API_HOST}/api/v1/campaigns/summary?${query}`);
};

// TODO - Get these status from API
export const getReportsStatuses = () => [
  {
    name: 'error',
    label: 'Error',
    id: 400,
  },
  {
    name: 'save',
    label: 'Save',
    id: 1,
  },
  {
    name: 'paused',
    label: 'Paused',
    color: 'success',
    id: 2,
  },
  {
    name: 'schedule',
    label: 'Schedule',
    id: 3,
  },
  {
    name: 'sending',
    label: 'Sending',
    id: 4,
  },
  {
    name: 'sent',
    label: 'Sent',
    id: 5,
  },
  {
    name: 'problem',
    label: 'Problem',
    id: 6,
  },
  {
    name: 'skipped',
    label: 'Skipped',
    id: 7,
  },
];

export const getReportStatusByName = (name) => {
  const statuses = getReportsStatuses();
  return statuses.find(status => status.name === name);
};

export const getReportStatusById = (id) => {
  const statuses = getReportsStatuses();
  return statuses.find(status => status.id === id);
};



// WEBPACK FOOTER //
// ./src/helpers/reports.js